import { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import GreenButton from "../../ui/GreenButton";
import * as XLSX from 'xlsx';



const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2{
    color: #575757;
  }

`;
const ScrollableContainer = styled.div`
  width: 100%;
  max-height: 80vh; 
  overflow-y: auto;
`;

const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  

  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;


export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  th, td {
    padding: 12px 8px;
    font-size: 14px;
    color: #333;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  tbody td {
    border-bottom: 1px solid #f0f0f0;
  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  @media (max-width: 780px) {
    min-width: 600px;
    th, td { padding: 10px 10px; font-size: 13px; }
  }
`;





const Tr = styled.tr`
  text-align: center;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;



const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;


const Td3 = styled.td`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 10px 0px;
  align-items: center;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 500px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Div2 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;



const Grid = ({ listaConsumoMes, tipoMaterial }) => {



  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//



  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(listaConsumoMes);
  const [isLoading, setIsLoading] = useState(true);

  const [tipoSelecionado, setTipoSelecionado] = useState('')

  console.log('tipoSelecionado', tipoSelecionado)

  //Input de pesquisa
  // Função de pesquisa
  const handleSearch = async (term, tipo) => {
    setIsLoading(true);

    try {
      const lowerTerm = term.toLowerCase();

      const filtered = listaConsumoMes.filter((item) => {
        const codMaterial = (item.COD_MATERIAL || '').toString().toLowerCase();
        const descricao = (item.DESC_MATERIAL || '').toLowerCase();
        const codTipo = (item.TIPO || '').toString();

        // Filtro por termo (texto livre)
        const passaBusca = codMaterial.includes(lowerTerm) || descricao.includes(lowerTerm);

        // Filtro por tipo (Select)
        const passaTipo = !tipo || codTipo === tipo;

        return passaBusca && passaTipo;
      });

      setFilteredUsers(filtered);
      setCurrentPage(1);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Atualiza a busca sempre que o termo OU o tipo mudam
  useEffect(() => {
    handleSearch(searchTerm, tipoSelecionado);
  }, [searchTerm, tipoSelecionado, listaConsumoMes]);





  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, listaConsumoMes]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);



  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };








  const exportarParaExcel = (dados, nomeArquivo = "consumo_mes.xlsx") => {
    if (!dados || dados.length === 0) {
      alert("Sem dados para exportar.");
      return;
    }

    // Cabeçalhos (exatamente como exibidos no <thead>)
    const headers = [
      "Código",
      "Descrição",
      "Uni",
      "Saldo Atual",
      "Total Entrada",
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
      "Total Saída",
    ];

    // Ordem dos campos vinda do seu objeto (currentItems)
    const fieldOrder = [
      "COD_MATERIAL",
      "DESC_MATERIAL",
      "UNIDADE",
      "SALDO_ATUAL",
      "TOTAL_ENTRADA",
      "JANEIRO",
      "FEVEREIRO",
      "MARCO",
      "ABRIL",
      "MAIO",
      "JUNHO",
      "JULHO",
      "AGOSTO",
      "SETEMBRO",
      "OUTUBRO",
      "NOVEMBRO",
      "DEZEMBRO",
      "TOTAL_SAIDA",
    ];

    // Constrói a planilha como AOA para preservar a ordem
    const aoa = [
      headers,
      ...dados.map((item) => fieldOrder.map((key) => item?.[key] ?? "")),
    ];

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    // Auto filtro no cabeçalho (opcional)
    const range = XLSX.utils.decode_range(ws["!ref"]);
    ws["!autofilter"] = { ref: XLSX.utils.encode_range(range) };

    // Larguras de coluna aproximadas (opcional)
    const colWidths = headers.map((h, idx) => {
      const maxLen = Math.max(
        String(h).length,
        ...dados.map((it) => String(it?.[fieldOrder[idx]] ?? "").length)
      );
      return { wch: Math.min(Math.max(maxLen + 2, 8), 40) };
    });
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Dados");

    XLSX.writeFile(wb, nomeArquivo);
  };


  console.log('currentItems', currentItems)

  return (


    <ScrollableContainer>
      <Container>
        <h2>Consumo Mês:</h2>



        <>
          <Td3 >
            <Input
              type="text"
              placeholder="Pesquisar... Ex: código, descrição, tipo ou subtipo"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />



            <Select value={itemsPerPage} onChange={(e) => {
              const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
              setItemsPerPage(value);
              setCurrentPage(1); // Resetar para a primeira página sempre que mudar
            }}>
              <option value={10}>10 por página</option>
              <option value={50}>50 por página</option>
              <option value={100}>100 por página</option>
              <option value="all">Todos</option>
            </Select>

            <Select
              value={tipoSelecionado}
              onChange={(e) => setTipoSelecionado(e.target.value)}
            >
              <option value="">Todos os tipos</option>
              {tipoMaterial.map((tipo) => (
                <option key={tipo.COD_TIPO} value={tipo.COD_TIPO}>
                  {tipo.DESC_TIPO}
                </option>
              ))}
            </Select>

            <Div>
              <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                <ImArrowLeft size={20} />
              </Button>
              <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
                <ImArrowRight size={20} />
              </Button>
            </Div>

            <Div2>
              <GreenButton onClick={() => exportarParaExcel(listaConsumoMes)}>
                Exportar Excel
              </GreenButton>
            </Div2>


          </Td3>

          {currentItems.length === 0 ? (
            <Tr>
              <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
                Não existem saldo para esse código ou período.
              </Td>
            </Tr>
          ) : (
            <TableWrapper>
              <Table>
                <thead>
                  <tr>
                    <th onClick={() => onColumnClick("COD_MATERIAL")} className={getSortClass("COD_MATERIAL")}>
                      Código: {getSortIcon("COD_MATERIAL")}
                    </th>

                    <th onClick={() => onColumnClick("DESC_MATERIAL")} className={getSortClass("DESC_MATERIAL")}>
                      Descrição: {getSortIcon("DESC_MATERIAL")}
                    </th>

                    <th onClick={() => onColumnClick("UNIDADE")} className={getSortClass("UNIDADE")}>
                      Uni: {getSortIcon("UNIDADE")}
                    </th>

                    <th onClick={() => onColumnClick("SALDO_ATUAL")} className={getSortClass("SALDO_ATUAL")}>
                      Saldo Atual: {getSortIcon("SALDO_ATUAL")}
                    </th>

                    <th onClick={() => onColumnClick("TOTAL_ENTRADA")} className={getSortClass("TOTAL_ENTRADA")}>
                      Total Entrada: {getSortIcon("TOTAL_ENTRADA")}
                    </th>
                    <th onClick={() => onColumnClick("JANEIRO")} className={getSortClass("JANEIRO")}>
                      Janeiro: {getSortIcon("JANEIRO")}
                    </th>

                    <th onClick={() => onColumnClick("FEVEREIRO")} className={getSortClass("FEVEREIRO")}>
                      Fevereiro: {getSortIcon("FEVEREIRO")}
                    </th>

                    <th onClick={() => onColumnClick("MARCO")} className={getSortClass("MARCO")}>
                      Março: {getSortIcon("MARCO")}
                    </th>

                    <th onClick={() => onColumnClick("ABRIL")} className={getSortClass("ABRIL")}>
                      Abril: {getSortIcon("ABRIL")}
                    </th>

                    <th onClick={() => onColumnClick("MAIO")} className={getSortClass("MAIO")}>
                      Maio: {getSortIcon("MAIO")}
                    </th>

                    <th onClick={() => onColumnClick("JUNHO")} className={getSortClass("JUNHO")}>
                      Junho: {getSortIcon("JUNHO")}
                    </th>
                    <th onClick={() => onColumnClick("JULHO")} className={getSortClass("JULHO")}>
                      Julho: {getSortIcon("JULHO")}
                    </th>

                    <th onClick={() => onColumnClick("AGOSTO")} className={getSortClass("AGOSTO")}>
                      Agosto: {getSortIcon("AGOSTO")}
                    </th>

                    <th onClick={() => onColumnClick("SETEMBRO")} className={getSortClass("SETEMBRO")}>
                      Setembro: {getSortIcon("SETEMBRO")}
                    </th>
                    <th onClick={() => onColumnClick("OUTUBRO")} className={getSortClass("OUTUBRO")}>
                      Outubro: {getSortIcon("OUTUBRO")}
                    </th>
                    <th onClick={() => onColumnClick("NOVEMBRO")} className={getSortClass("NOVEMBRO")}>
                      Novembro: {getSortIcon("NOVEMBRO")}
                    </th>
                    <th onClick={() => onColumnClick("DEZEMBRO")} className={getSortClass("DEZEMBRO")}>
                      Dezembro: {getSortIcon("DEZEMBRO")}
                    </th>
                    <th onClick={() => onColumnClick("TOTAL_SAIDA")} className={getSortClass("TOTAL_SAIDA")}>
                      Total Saída: {getSortIcon("TOTAL_SAIDA")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {currentItems.map((item, i) => (
                    <tr key={i}>

                      <td >{item.COD_MATERIAL}</td>
                      <td >{item.DESC_MATERIAL}</td>
                      <td >{item.UNIDADE}</td>
                      <td >{item.SALDO_ATUAL}</td>
                      <td >{item.TOTAL_ENTRADA}</td>
                      <td >{item.JANEIRO}</td>
                      <td >{item.FEVEREIRO}</td>
                      <td >{item.MARCO}</td>
                      <td >{item.ABRIL}</td>
                      <td >{item.MAIO}</td>
                      <td >{item.JUNHO}</td>
                      <td >{item.JULHO}</td>
                      <td >{item.AGOSTO}</td>
                      <td >{item.SETEMBRO}</td>
                      <td >{item.OUTUBRO}</td>
                      <td >{item.NOVEMBRO}</td>
                      <td >{item.DEZEMBRO}</td>
                      <td >{item.TOTAL_SAIDA}</td>



                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableWrapper>

          )}

        </>


      </Container>
    </ScrollableContainer>
  );
};


export default Grid;
